export function maxMessageId(messages = []) {
  return messages.reduce((max, message) => {
    const id = Number(message?.id);

    return Number.isFinite(id) && id > max ? id : max;
  }, 0);
}

export function mergeAnswerResponse(existingSession, answerPayload) {
  return mergeSessionResponse(existingSession, answerPayload);
}

export function mergeSessionResponse(existingSession, incomingPayload) {
  if (!existingSession) {
    return incomingPayload;
  }

  const existingMessages = existingSession.messages ?? [];
  const incomingMessages = incomingPayload.messages ?? [];
  const mergedById = new Map(existingMessages.map((message) => [message.id, message]));

  incomingMessages.forEach((message) => {
    mergedById.set(message.id, message);
  });

  const mergedMessages = [...mergedById.values()].sort((left, right) => {
    const leftId = Number(left.id) || 0;
    const rightId = Number(right.id) || 0;

    return leftId - rightId;
  });

  return {
    ...existingSession,
    ...incomingPayload,
    messages: mergedMessages,
    current_question: incomingPayload.current_question ?? existingSession.current_question,
    progress: incomingPayload.progress ?? existingSession.progress,
  };
}
